<template>
	<div id="app">
		<Header></Header>
		<silderbar @scrollToTop="scrollToTop"></silderbar>
		<!-- <keep-alive> -->
		<router-view />
		<!-- </keep-alive> -->
		<!-- <Footer></Footer> -->
	</div>
</template>

<script>
	
	import {getEventBus} from "./api/eventBus"
	import silderbar from '@/components/rightSidebar.vue';
	export default {
		name: 'App',
		components: {
			silderbar
		},
		methods: {
			scrollToTop(){
				  
				getEventBus().$emit("scrollToTopz")
			}
		}
	}
</script>

<style>
	
	
	.userScorll {
	  -ms-overflow-style: none;  /* IE and Edge */
	  scrollbar-width: none;  /* Firefox 64 */
	}
	
	.userScorll::-webkit-scrollbar {
		width: 0 !important;
	}
	.paddingLR78 {
		padding-left: 9.15vw;
		padding-right:9.15vw;;
	}
	.marginLR78 {
		margin-left: 9.15vw;
		margin-right:9.15vw;;
	}
	.margintopHead
	{
		margin-top: 66px;
	}
	.margintopHead30
	{
		margin-top: 96px;
	}
	* {
		padding: 0;
		margin: 0;
	}

	#app {
		font-family: Source Han Sans CN;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}

	.Page {
		width: 1100px;
		margin: 0 auto;
	}

	h1 {
		text-align: center;
		font-size: 28px;
		font-family: SourceHanSansSC;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
	}

	h2 {
		font-size: 17px;
		font-family: SourceHanSansSC;
		font-weight: 400;
		color: #999999;
		margin-top: 5px;
		text-align: center;
	}

	.el-card {
		border: none;
	}

	.el-card__body {
		padding: 0 !important;
	}

	.el-menu {
		background: none;
		border-bottom: none !important;
		background-color: transparent !important;
	}

	/* 移除菜单项的背景色 */
	.el-menu--horizontal>.el-menu-item,
	.el-menu--horizontal>.el-submenu .el-submenu__title {
		background-color: transparent !important;
		font-size: 15px;
		padding:0 25px!important;
	}

	/* 移除菜单项悬停时的背景色 */
	.el-menu--horizontal>.el-menu-item:hover,
	.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
		background-color: transparent !important;
	}

	/* 移除激活状态的背景色和底部边框 */
	.el-menu--horizontal>.el-menu-item.is-active,
	.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
		background-color: none !important;
		border-bottom: #fff !important;
	}

	/* 设置下拉菜单的背景色为透明 */
	.el-menu--popup {
		background-color: transparent !important;
	}

	.el-menu--popup .el-menu-item,
	.el-menu--popup .el-submenu__title {
		background-color: transparent !important;
	}

	/* 移除下拉菜单项悬停时的背景色 */
	.el-menu--popup .el-menu-item:hover,
	.el-menu--popup .el-submenu__title:hover {
		background-color: transparent !important;
	}


	/* 修改一级导航hover状态的字体颜色 */
	.el-menu--horizontal>.el-menu-item:hover,
	.el-menu--horizontal>.el-submenu .el-submenu__title:hover {
		color: #1C6CE6 !important;
	}

	/* 修改激活状态的字体颜色 */
	.el-menu--horizontal>.el-menu-item.is-active,
	.el-menu--horizontal>.el-submenu.is-active .el-submenu__title {
		color: #1C6CE6 !important;
	}

	/* 修改二级菜单的背景色和样式 */
	.el-menu--popup {
		background-color: #fff !important;
		padding: 5px 0;
	}

	/* 二级菜单项的样式 */
	.el-menu--popup .el-menu-item,
	.el-menu--popup .el-submenu__title {
		background-color: #fff !important;
		color: #333 !important;
	}

	/* 二级菜单hover状态 */
	.el-menu--popup .el-menu-item:hover,
	.el-menu--popup .el-submenu__title:hover {
		background-color: #fff !important;
		color: #1C6CE6 !important;
	}
	.el-menu--popup .el-menu-item.is-active,
	.el-menu--popup .el-submenu__title.is-active {
		background-color: #fff !important;
		color: #1C6CE6 !important;
	}

	/* 修改一级菜单中的链接颜色 */
	.el-menu--horizontal>.el-menu-item a {
		color: #fff !important;
	}

	/* 修改禁用状态的菜单项颜色 */
	.el-menu--horizontal>.el-menu-item.is-disabled {
		color: rgba(255, 255, 255, 0.6) !important;
	}

	.el-menu--horizontal>.el-submenu .el-submenu__icon-arrow {
		display: none;
	}

	.el-menu--popup {
		min-width: auto !important;
		width: auto !important;
		padding: 5px 20px !important;
		white-space: nowrap;
	}

	/* 二级菜单项的样式 */
	.el-menu--popup .el-menu-item {
		min-width: auto !important;
		padding: 0 10px !important;
		width: auto !important;
	}

	/* 确保文字不换行 */
	.el-menu--popup .el-menu-item span,
	.el-menu--popup .el-submenu__title span {
		white-space: nowrap;
	}
	.el-carousel__container{
		height:100%!important;
	}
	.textPos{
		position:absolute;
		right:10%;
		top:30%;
	}
	.textPos h2{
		font-size:40px;
		color:#fff;
		font-weight:bold;
		border-bottom:1px solid #fff;
		width:260px;
		text-align:left;
	}
	.el-breadcrumb{
		float:right;
		margin-top:5px;
	}
	.el-breadcrumb__inner{
		color:#fff!important;
	}
	.el-breadcrumb__separator{
		color:#fff!important;
	}
	
	
	
</style>


// WEBPACK FOOTER //
// src/App.vue